var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookKite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 63,
    viewBox: "0 0 56 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 60H6C2.68629 60 0 57.3137 0 54V6C0 2.68629 2.6863 0 6.00001 0H34.1895C35.9701 0 37.6588 0.79091 38.7988 2.15882L45.6093 10.3312C46.5079 11.4095 47 12.7687 47 14.1724V54C47 57.3137 44.3137 60 41 60Z",
    fill: "#D3DDEA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 48,
    width: 12,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 48,
    width: 12,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 38,
    width: 12,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 38,
    width: 12,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 28,
    width: 12,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 28,
    width: 12,
    height: 4,
    rx: 2,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 39,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#2C70AC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 45,
    width: 1.5,
    height: 12,
    rx: 0.75,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 1.5,
    height: 12,
    rx: 0.75,
    transform: "matrix(0 -1 -1 0 50 51.5)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookKite);
export default __webpack_public_path__ + "static/media/bookKite.8d8c362fe3700167cd84a211baab8f56.svg";
export { ForwardRef as ReactComponent };